import { Autocomplete, TextField } from "@mui/material";
import Component from "components/Component";
import DefaultLoader from "components/common/DefaultLoader";
import Disabled from "components/common/Disabled";
import { useDispatch, useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as programActions from "store/actions/input/program/programActions";
import * as programSelectors from "store/selectors/input/program/programSelectors";

const SubmissionTags = () => {
  const dispatch = useDispatch();
  const program = useSelector(programSelectors.selectProgram);
  const selectedTags = program?.tags ?? [];

  const {
    data: generalConfiguration,
    isLoading,
  } = staticDataService.useConfigQuery("general_configuration");

  const activeOptions = generalConfiguration?.submissionTags?.all ?? [];
  const allOptions = [
    ...(generalConfiguration?.submissionTags?.all ?? []),
    ...(generalConfiguration?.submissionTags?.deleted ?? []),
  ];

  const noOptionsText =
    activeOptions.length === 0 ? "No tags configured" : "No matching tags";

  const normalizedActiveOptions = activeOptions.map((option) => ({
    value: option.key,
    label: option.name,
  }));
  const normalizedAllOptions = allOptions.map((option) => ({
    value: option.key,
    label: option.name,
  }));

  return (
    <Component title={"Tags"}>
      {isLoading ? (
        <DefaultLoader
          style={{
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          size={60}
        />
      ) : (
        <Disabled ifReadOnly>
          <Autocomplete
            multiple
            options={normalizedActiveOptions}
            value={selectedTags.map((tagValue) =>
              normalizedAllOptions.find((option) => option.value === tagValue)
            )}
            getOptionLabel={(option) => option?.label ?? "?"}
            isOptionEqualToValue={(option, selected) =>
              option?.value === selected?.value
            }
            onChange={(_, selections) => {
              const tags = (selections ?? []).map(
                (selection) => selection.value
              );
              dispatch(
                programActions.updateProgram({
                  tags,
                })
              );
            }}
            noOptionsText={noOptionsText}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant={"filled"}
                label={"Tags"}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Disabled>
      )}
    </Component>
  );
};

export default SubmissionTags;
